import { makeStyles } from '@mui/styles';
import { OFFSET_HEIGHT } from '../constants';

export const useStyles = makeStyles((theme) => ({
  section: ({ isOver }) => ({
    padding: theme.spacing(1),
    width: '300px',
    flexShrink: 0,
    border: '1px solid',
    borderColor: isOver ? '#d8dde1' : 'transparent',
    // background: '#00000005',
    borderRadius: '6px',
    minHeight: '430px',
    '&:has($header:hover)': {
      borderColor: '#d8dde1',
    },
  }),
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2.5),
  },
  addTaskBtn: {
    color: 'inherit',
    opacity: 0.5,
    scale: 0.95,
    transition: 'all 0.3s ease',
    '&:hover': {
      scale: 1,
      opacity: 1,
      letterSpacing: '0.5px',
    },
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    alignItems: 'center',
    width: '100%',
    maxWidth: '100%',
  },
  actionBox: {
    display: 'flex',
    gap: theme.spacing(0.5),
    '& > *': {
      borderRadius: '6px',
      padding: theme.spacing(0.5),
    },
  },
  rootStack: {
    height: `calc(100vh - ${OFFSET_HEIGHT}px)`,
    display: 'flex',
    gap: theme.spacing(2),
    width: 'fit-content',
  },
  taskStack: ({ isOver }) => ({
    background: isOver ? '#0000000f' : '#00000005',
    height: `calc(100vh - ${OFFSET_HEIGHT}px)`,
    borderRadius: '15px',
    paddingTop: '12px',
    overflowY: 'auto',
  }),
  infiniteScroll: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    minHeight: '150px',
  },
  projectName: {
    cursor: 'pointer',
    textTransform: 'capitalize',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  avatar: {
    width: '26px',
    height: '26px',
    fontSize: '12px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
